
<script lang="ts" setup>
import {useModyApi} from "~/middelware/ModyApi";
import greenTick from "~/assets/img/green_tick.svg"
import {tryCatch} from "standard-as-callback/built/utils";
import type {AxiosError} from "axios";
const router = useRouter()
const showErrorModal = ref(false)
const errorMessage = ref("")
const email = ref("")
const username = ref("")
const password = ref("")
const api = useModyApi()
const registrationLoading = ref(false)
const registrationSuccess = ref(false)
async function register(){
  registrationLoading.value = true
  try {
    const response = await api.post("auth/local/register",{
      email:email.value,
      username:username.value != "" ? username.value : email.value,
      password:password.value
    })
    registrationSuccess.value = true
  }
  catch (e){
    errorMessage.value = e.response.data.error.message
    showErrorModal.value = true
  }
  registrationLoading.value = false
}
</script>
<template>

  <div class="container" style="max-width: 600px">
    <h2>Registrierung</h2>
    <form v-if="!registrationSuccess" @submit.prevent=register class="mb-3">
      <InputGroup class="mb-3">
        <InputGroupAddon>
          <i class="pi pi-user"></i>
        </InputGroupAddon>
        <InputText id="username" placeholder="Username" autocomplete="username" v-model="username"  />
      </InputGroup>
      <InputGroup class="mb-3">
        <InputGroupAddon>
          <i class="pi pi-at"></i>
        </InputGroupAddon>
        <InputText id="email" required placeholder="Email" autocomplete="email" v-model="email"  />
      </InputGroup>
      <InputGroup class="mb-3">
        <InputGroupAddon>
          <i class="pi pi-lock"></i>
        </InputGroupAddon>
        <InputText id="password" required type="password" placeholder="Passwort" autocomplete="new-password" v-model="password"  />
      </InputGroup>

      <Button type="submit" class="text-center">
        Registrieren
      </Button>
      <ProgressSpinner v-if="registrationLoading" class="ms-3" style="width:20px;height:20px;" strokeWidth="8"/>
    </form>
    <div v-else class="text-center d-flex" style="height:50vh">
      <div class="m-auto">
        <Image :src="greenTick"></Image>
        <h3>Registrierung erfolgreich</h3>
        <p>Bitte prüfe nun deinen Email-Eingang, dort müsste sich ein Bestätigungsmail befinden. Bitte klicke auf den
        Link darin und bestätige so deine Registrierung!</p>
        <Button @click="router.push('/account')">Zum Login</Button>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="showErrorModal" modal header="Fehler">
    <p>
      Bei der Anmeldung ist etwas schief gelaufen.
    </p>
    <p>{{errorMessage}}</p>
  </Dialog>

</template>